// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".choose-btn[data-v-0f7cc87c]{font-size:16px;font-weight:700;line-height:16px;text-transform:none}.choose-btn[data-v-0f7cc87c],.replace-btn[data-v-0f7cc87c]{background-color:var(--v-primary-base)!important;color:var(--v-primary-text-base)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
